module.exports = __webpack_public_path__ + "img/line-chart-light-01.ca3de936.jpg";